import { message } from 'antd';
import { put, takeLatest } from 'redux-saga/effects';
import { StoreActionProps } from 'data/core';
import { logger } from 'services';
import {
  addPhaseDependencyInProjectTemplate,
  AddPhaseDependencyInProjectTemplatePayload,
  updatePhaseDependenciesInProjectTemplate,
} from '../../actions';
import {
  addProjectTemplatePhaseDependency,
  updateProjectTemplatePhaseDependencies,
} from '../../slices';

function* addTemplatePhaseDependencySaga(
  action: StoreActionProps<AddPhaseDependencyInProjectTemplatePayload>,
) {
  try {
    const {
      payload: { phaseId, dependentPhaseId, dependencyType, lag },
    } = action;

    yield put(
      addProjectTemplatePhaseDependency({
        dependentPhaseId,
        phaseId,
        dependencyType,
        lag,
      }),
    );
  } catch (error) {
    logger.error('addProjectTemplatePhaseDependency failed', { error });

    message.error(
      'There was an error updating phase dependencies, please try later',
    );
  }
}

function* updateTemplatePhaseDependenciesSaga(
  action: StoreActionProps<{
    phaseId: number;
    dependentPhases: {
      projectPhaseId: number;
      dependencyType: string;
      lag: number | null;
      phaseName?: string;
    }[];
  }>,
) {
  try {
    const {
      payload: { phaseId, dependentPhases },
    } = action;

    yield put(
      updateProjectTemplatePhaseDependencies({
        phaseId,
        dependentPhases,
      }),
    );
  } catch (error) {
    logger.error('updateProjectTemplatePhaseDependencies failed', { error });

    message.error(
      'There was an error updating phase dependencies, please try later',
    );
  }
}

export function* watchAddTemplatePhaseDependencySaga(): Generator {
  yield takeLatest(
    addPhaseDependencyInProjectTemplate.type,
    addTemplatePhaseDependencySaga,
  );

  yield takeLatest(
    updatePhaseDependenciesInProjectTemplate.type,
    updateTemplatePhaseDependenciesSaga,
  );
}
